document.addEventListener('turbolinks:load', function () {
    if ($('.organizations.other_admin_settings, .organizations.new, #organization_edit').length === 0) {
        return false
    }

    // adopted codes: multi-select; typing a code that is not in the list adds it as an "Other Code"
    let adoptedCodeSelect = $('#adopted_code_list')
    if (adoptedCodeSelect.length > 0 && $.fn.select2) {
        adoptedCodeSelect.select2({
            width: '100%',
            placeholder: adoptedCodeSelect.data('placeholder'),
            closeOnSelect: false,
            dropdownCssClass: 'adopted-codes-dropdown',
            tags: true,
            createTag: function (params) {
                const term = $.trim(params.term).replace(/,/g, '')
                return term === '' ? null : { id: term, text: term }
            }
        })
            // closeOnSelect: false keeps the typed text after a pick; clear it so the next code starts fresh
            .on('select2:select', function () {
                $(this).data('select2').$container.find('.select2-search__field').val('').trigger('input')
            })
    }

    $(document).off('change', '#type_Other').on('change', '#type_Other', function () {
        let otherPermitField = $('#other_current_service')
        if ($(this).is(':checked')) {
            otherPermitField.removeClass('d-none')
        } else {
            otherPermitField.addClass('d-none')
        }
    })

    $(document).off('change', '#organization_contractor_registration_renew_type').on('change', '#organization_contractor_registration_renew_type', function () {
        let value = $(this).val()
        let annualRenewOption = $('.annualRenewOption')
        if (value === 'annually') {
            annualRenewOption.removeClass('d-none')
        } else {
            annualRenewOption.addClass('d-none')
        }
    })

    $(document).off('change', '#organization_contractor_portal_enabled').on('change', '#organization_contractor_portal_enabled', function () {
        let contractorPortalDependentQuestions = $('.contractor-portal-dependent-questions')
        if ($(this).is(':checked')) {
            contractorPortalDependentQuestions.removeClass('d-none')
        } else {
            contractorPortalDependentQuestions.addClass('d-none')
        }
    })
});